export default __webpack_public_path__ + "static/media/s2.d028553a.png";